
import {Component, Vue} from "vue-property-decorator";
import Template from "@/views/system-management/template/index.vue";
import {createAppVersion, deleteVersion, getAppVersion, updatePattern, uploadAppVersion} from "@/api/app-version";
import {doDownload} from "@/utils/oss-download";
import { postRefresh } from "@/api/users"

@Component({
  name: "appVersionControl",
  components: {Template}
})
export default class extends Vue {
  private listQuery = {
    type: "",
    pageNumber: 1,
    pageSize: 1000,
  };

  private isIos = false;
  private appVersionId: string;

  private params = {
    type: "ANDROID",
    version: null,
    updatePattern : null,
    packageOssId: null,
    remark: null,
  }
  private create: string;

  private addVersionDialog = false;
  private tableData: AppVersion[] = [];

  private files: File[] = [];

  created() {
    this.getList();
  }

  private async getList() {
    const date:any = await getAppVersion(this.listQuery);
    this.tableData = date.content;
  }

  private onSelectionChange() {
    this.isIos = this.params.type === "IOS";
  }

  private async addAppVersion(value: string) {
    this.create = value;
    this.addVersionDialog = true;
  }

  private async handleRefresh() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await postRefresh().then(res => {
      this.$notify({
        title: "成功",
        message: "刷新成功！",
        type: "success",
        duration: 2000,
      });
      location.reload();
      loading.close();
    }).catch(err => {
      console.log(err)
    })
  }

  private updateAppVersion(row) {
    this.params = row;
    this.create = "edit";
    this.appVersionId = row.id;
    this.addVersionDialog = true;
  }

  private downloadApp(row: AppVersion) {
    doDownload(row.ossUrl);
  }

  private addFile(file: File) {
    this.files.push(file);
  }

  private async handleUpload() {
    let formData = new window.FormData;
    formData.append("file", this.files.pop());
    const ossUrl = await uploadAppVersion(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000
    });
    this.params.packageOssId = ossUrl;
  }


  private async createAppVersion() {
    if (this.params.type === "IOS") {
      this.params.packageOssId = "https://www.pgyer.com/aCed";
    }
    if (this.create === "create") {
      await createAppVersion(this.params);
    }else {
      await updatePattern(this.appVersionId, this.params);
    }
    this.addVersionDialog = false;
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000
    });
    await this.getList();
  }

  private async updatePattern(row: AppVersion) {
    await updatePattern(row.id ,row);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000
    });
    await this.getList();
  }

  private async deleteVersion(row: AppVersion) {
    await deleteVersion({ids:[row.id]});
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
    await this.getList();
  }
}

class AppVersion {
  id: string;
  type: string;
  version: string;
  packageOssId: string;
  ossUrl: string;
  updatePattern: boolean;
  createAt: string;
  remark: string;
}
